import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=2bc3d388&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=2bc3d388&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3d388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc3d388')) {
      api.createRecord('2bc3d388', component.options)
    } else {
      api.reload('2bc3d388', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=2bc3d388&scoped=true", function () {
      api.rerender('2bc3d388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat.vue"
export default component.exports